import { type ReactNode } from 'react';
import { motion, type MotionProps } from 'framer-motion';
import { classes } from 'src/modules/shared/utils/styles.util';

interface TimelineItemShellProps
  extends Pick<MotionProps, 'initial' | 'animate'> {
  children: ReactNode;
  className?: string;
}

export const TimelineItemShell: React.FC<TimelineItemShellProps> = ({
  children,
  className,
  initial = { opacity: 0, y: 12 },
  animate = { opacity: 1, y: 0 },
}) => {
  return (
    <motion.div initial={initial} animate={animate} className="w-full">
      <div
        className={classes(
          'rounded-2xl border border-neutral-100 bg-white px-3 py-2 shadow-sm transition-colors duration-150',
          'hover:shadow-md focus-within:shadow-md focus-within:ring-2 focus-within:ring-primary-100 focus-within:ring-offset-0',
          className
        )}
      >
        {children}
      </div>
    </motion.div>
  );
};
